import React from 'react';
import UsLandingSection from '../../components/Nosotros/UsLandingSection';
import OurComitmentSection from '../../components/Nosotros/OurComitmentSection';
import AboutSolutions from '../../components/Nosotros/AboutSolutions';
import OurCeo from '../../components/Nosotros/OurCeo';
import PathToSuccess from '../../components/Nosotros/PathToSuccess';

const Nosotros = () => {
  return (
      <main className='nosotros-section-body'>
        <section id="us-landing-section">
          <UsLandingSection/>
        </section>
        <section id="our-comitment-section">
          <OurComitmentSection/>
        </section>
        <section id="about-solutions-section">
          <AboutSolutions/>
        </section>
        <section id="our-ceo-section">
          <OurCeo/>
        </section>
        <section id="path-to-success-section">
          <PathToSuccess/>
        </section>
      </main>
  );
};

export default Nosotros;